import React from 'react';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line no-restricted-imports
import type { Theme } from '@mui/material';
import MuiTableCell, {
  type TableCellProps as MuiTableCellProps,
} from '@mui/material/TableCell';
import MuiTableContainer, {
  type TableContainerProps,
} from '@mui/material/TableContainer';
import makeStyles from '@mui/styles/makeStyles';
import classNames from 'classnames';

// We're not touching these, but exporting them for one-stop shop convenience.
// If we DO want to do something with these in the future, this will help in
// future-proofing these components.
export { default as Table } from '@mui/material/Table';
export { default as TableBody } from '@mui/material/TableBody';
export { default as TableHead } from '@mui/material/TableHead';
export { default as TableRow } from '@mui/material/TableRow';
export { default as TableSortLabel } from '@mui/material/TableSortLabel';

const useStyles = makeStyles((theme: Theme) => ({
  tableContainer: {
    '& thead': {
      [theme.breakpoints.down('md')]: {
        display: 'none',
      },
    },
    '& tbody tr': {
      [theme.breakpoints.down('md')]: {
        alignItems: 'center',
        display: 'flex',
        flexWrap: 'wrap',
        padding: 0,
        '&:first-of-type': {
          borderWidth: '1px 0',
        },
      },
    },
    '& tbody td': {
      [theme.breakpoints.down('md')]: {
        alignItems: 'baseline',
        display: 'flex',
        padding: '0.125rem 0',
        order: '5000',
        width: '100%',
      },
    },
  },
}));

export function TableContainer({
  className = '',
  ...rest
}: TableContainerProps) {
  const styles = useStyles();
  return (
    <MuiTableContainer
      className={classNames(className, styles.tableContainer)}
      {...rest}
    />
  );
}

type TableCellProps = MuiTableCellProps & {
  children?: React.ReactNode;
  className?: string;
  classes?: {
    root?: string;
    label?: string;
  };
  label?: string;
};

export function TableCell({
  children,
  className = '',
  classes,
  ...rest
}: TableCellProps) {
  return (
    <MuiTableCell className={classNames(classes?.root, className)} {...rest}>
      {rest.label && children && (
        <div className={classNames(classes?.label, 'mr-auto md:hidden')}>
          {rest.label}
        </div>
      )}
      {children}
    </MuiTableCell>
  );
}
